import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DropTarget as dropTarget } from 'react-dnd';
import AutocodeGridBodyRow from './AutocodeGridBodyRow';
import AC_GRID from '../AutocodeTypes';
import AutocodeCustomDragLayer from '../AutocodeCustomDragLayer';

const target = {
  canDrop(props, monitor) {
    return monitor.getItem() && props;
  },
  drop(props, monitor) {
    if (props.onGridDrop) {
      props.onGridDrop(
        monitor.getItem(),
        monitor.getItemType(),
        props.gridCategory
      );
    }
  },
};

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
});

const AutocodeGridBody = props => {
  const { gridarray, minRows, height, partsToShow } = props;

  const getSelectedEntries = () =>
    gridarray.filter(item => props.selectedData.includes(item.id));

  const minRowsArray = [];
  // let mingridarray = [];
  for (let index = 0; index < minRows; index += 1) {
    minRowsArray.push({ index: index + 1 });
  }

  if (minRowsArray.length > gridarray.length) {
    for (
      let index = gridarray.length;
      index < minRowsArray.length;
      index += 1
    ) {
      gridarray.push({ index: index + 1 });
    }
  }

  const emptyRowsRender = () => {
    return minRowsArray.map(row => (
      <div className="grid-body-container" key={row.index}>
        <AutocodeGridBodyRow partsToShow={partsToShow} />
      </div>
    ));
  };

  const dataRowsRender = () => {
    const {
      connectDropTarget,
      onGridDrop,
      gridCategory,
      minwidth,
      columns,
      selectedData,
      clearSelections,
      setCheckBlur,
      partsToShow,
      handleRowMouseUp,
      handleRowMouseDown,
    } = props;

    return connectDropTarget(
      <div
        tabIndex="-1"
        style={{
          height: height ? `${height}` : `${minRows * 30}px`,
          minWidth: `${minwidth}`,
          overflowY: 'auto',
          overflowX: 'hidden',
          outline: 'none',
        }}
        onBlur={() => clearSelections()}
      >
        {gridarray.map(row => (
          <div
            className={
              selectedData.includes(row.id)
                ? 'grid-body-container selected'
                : 'grid-body-container'
            }
            key={row.id}
          >
            <AutocodeCustomDragLayer
              items={getSelectedEntries()}
              type={AC_GRID.AC_GRID_1}
            />
            <AutocodeGridBodyRow
              rowData={row}
              onGridDrop={onGridDrop}
              gridCategory={gridCategory}
              getSelectedEntries={getSelectedEntries}
              columns={columns}
              clearSelections={clearSelections}
              setCheckBlur={setCheckBlur}
              partsToShow={partsToShow}
              gridarray={gridarray}
              handleRowMouseDown={handleRowMouseDown}
              handleRowMouseUp={handleRowMouseUp}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <Fragment>
      {gridarray.length ? dataRowsRender() : emptyRowsRender()}
    </Fragment>
  );
};

AutocodeGridBody.propTypes = {
  gridarray: PropTypes.arrayOf(PropTypes.object),
  minRows: PropTypes.number,
  minwidth: PropTypes.number,
  height: PropTypes.string,
  gridCategory: PropTypes.string,
  columns: PropTypes.number,
  connectDropTarget: PropTypes.func,
  onGridDrop: PropTypes.func,
  selectedData: PropTypes.arrayOf(PropTypes.string),
  clearSelections: PropTypes.func,
  setCheckBlur: PropTypes.func,
  partsToShow: PropTypes.shape({}),
};

export default dropTarget(
  [AC_GRID.AC_GRID_1, AC_GRID.AC_GRID_2, AC_GRID.AC_DEFINITIONS],
  target,
  collect
)(AutocodeGridBody);
